import {OpeningTimes} from "./openingtimes";
import {IOpeningTimesPayload} from "../interfaces/openingtimes";
import {COMPLETE_PAYLOAD} from "../constants/config";
import {Http} from "@angular/http";
import {API} from "../services/api.service";

interface CustomerPages {
  url: string;
  name: string;
  title: string;
}

const AVAILABLE_PAYMENT_METHODS = {
  "cash": {
    "title": "mit Bargeld",
    "icon": "",
    "color": "",
    "key": "cash"
  },
  "paypal": {
    "title": "mit PayPal",
    "icon": "",
    "color": "",
    "key": "paypal"
  },
}

export class Customer {
  static CACHED: Customer | boolean = false;
  public title: string;
  public id: number;
  public name: string;

  public modules = new CustomerModules();
  public orderTypes: IOrderTypesPayload;
  public paymentMethods: IPaymentMethodPayload[];
  public openingTimes: OpeningTimes;
  public minimumOrderValues: IMinimumOrderValuesPayload;
  public socialMedia: Map<string, string>;
  public pages: CustomerPages[] = [];
  public paymentProviders:any;
  public latitude: number;
  public closedMessage: string;
  public longitude: number;
  public defaultIngredients;

  constructor(payload: ICustomerPayload) {
    if (!payload) {
      return new Customer(
        COMPLETE_PAYLOAD as any
      );
    }
    this.title = (payload.customer).title;
    this.id = (payload.customer).id;


    let query = location.search;

    if(query == ""){
      this.name = (payload.customer).name;
    }
    else{
      let params = new URLSearchParams(query);
      this.name = params.get("customer");
    }

    this.paymentProviders = (payload.paymentProviders);
    this.defaultIngredients = payload.defaultIngredients;
    this.latitude = (payload.customer as any).latitude;
    this.longitude = (payload.customer as any).longitude;
    this.closedMessage = (payload.customer as any).closedMessage;
    if (payload.paymentMethods){
      this.paymentMethods = payload.paymentMethods.map(e => AVAILABLE_PAYMENT_METHODS[e]);
    } else {
      this.paymentMethods = [];
    }
    Object.keys(payload.modules).forEach((module: string) => {
      this.modules.addModule(module, payload.modules[module]);
    });

    this.orderTypes = (payload.settings.order_types);
    this.openingTimes = new OpeningTimes(payload.settings.opening_times);
    this.minimumOrderValues = (payload.settings.minimum_order_values);
    this.socialMedia = payload.social_media;
    this.pages = payload.pages as any;
  }

  /**
   * Load metadata from API endpoint
   */
  static get(http:any){
    return http.get(`${API.BASE_HOST}/customers/${API.CUSTOMER}/`).map(req => req.json());
  }

  static cachedOrCreate(http: any) {
    http.get(`${API.BASE_HOST}/customers/${API.CUSTOMER}/`).map(req => req.json()).subscribe((payload: ICustomerPayload) => {
      Customer.CACHED = new Customer(payload);
    });

    if (Customer.CACHED) {
      return Customer.CACHED;
    }
    return new Customer(COMPLETE_PAYLOAD as any);
  }
}


class CustomerModules {
  public modules: Object = {};

  public addModule(name, opts = {}) {
    this.modules[name] = opts;
  }

  public hasModule(name) {
    return (this.modules[name] && this.modules[name].enabled);
  }
}


export interface ICustomerPayload {
  customer: ICustomerMetadata;
  modules: ICustomerModulesPayload;
  theme: ICustomerTheme[],
  settings: ICustomerSettingsPayload,
  defaultIngredients: any,
  paymentMethods: any,
  paymentProviders:any,
  social_media: Map<string, string>,
  pages: IPagesPayload[],
  latitude: number;
  longitude: number;
  closedMessage: string;
}

export interface IPagesPayload {
  title: string;
  url: string;
  id: number;
}

export interface ICustomerTheme {
  title: string;
  colors: Map<string, string>;
  scss: string;
}

export interface ICustomerSettingsPayload {
  order_types: IOrderTypesPayload,
  opening_times: IOpeningTimesPayload,
  minimum_order_values: IMinimumOrderValuesPayload
}

export interface IOrderTypesPayload extends Array<IOrderTypesPayload>{
  title: string,
  needs_shipping?: boolean | null,
  requires_mov: boolean | number
}

export interface IPaymentMethodsPayload extends Array<IPaymentMethodPayload[]> {
};

export interface IPaymentMethodPayload {
  value: IPaymentMethodPayloadValue;
  name: string;
  key: string;
  title: string;
  color: string;
  icon: string;
}

export type IPaymentMethodPayloadValue = "cash" | "paypal" | "heidelpay_cc" | "stripe" | "klarna";


export interface IMinimumOrderValuesPayload extends Array<IMinimumOrderValuePayload[]> {
}

export interface IMinimumOrderValuePayload {
  title: string;
  postalcode: string;
  price: Number;
}

export interface ICustomerMetadata {
  title: string;
  id: number;
  name: string;
}

export interface ICustomerModulePayload {
  enabled: number | boolean
}

export interface ICustomerModulesPayload extends Map<string, ICustomerModulePayload> {
}



// WEBPACK FOOTER //
// ./src/app/classes/customer.ts